<template>
  <d-page>
    <swipe class="my-swipe" :autoplay="3000" @change="onChange">
      <swipe-item v-for="(image, index) in images" :key="index">
        <img class="img" :src="image" alt="" />
      </swipe-item>

      <div class="custom-indicator" slot="indicator">{{ active + 1 }}/{{ total }}</div>
    </swipe>

    <div class="content">
      <h2 class="content-title">标题名称标题名称标题名称标题名称标题名称标题名称标题名称标题名称标题名…</h2>

      <p class="content-date">2022-04-20 17:06:08</p>

      <p class="content-label">内容描述</p>

      <p class="content-text">
        传播贵州美景，最美多彩贵州。将贵州美景分享给世界，为家乡排出经典作品，留下永恒记忆，
        回到家看歌舞画册出版环境和对的。最美多彩贵州。将贵州美景分享给世界，为家乡排出经典作品，
        留下永恒记忆，回到家看歌舞画册出版环境和对的。传播贵州美景，最美多彩贵州。将贵州美景分享给世界，
        为家乡排出经典作品，留下永恒记忆，回到家看歌舞画册出版环境和对的。最美多彩贵州。将贵州美景分享给世界，
        为家乡排出经典作品，留下永恒记忆，回到家看歌舞画册出版环境和对的。传播贵州美景，最美多彩贵州。将贵州美景分享给世界，
        为家乡排出经典作品，留下永恒记忆，回到家看歌舞画册
      </p>

      <d-footer>
        <div class="footer">
          <button class="cancel">已报名</button>
          <button class="confirm">立即报名</button>
        </div>
      </d-footer>
    </div>
  </d-page>
</template>

<script>
  import { Swipe, SwipeItem } from 'vant'
  import DFooter from '../../components/d-footer/index'

  export default {
    name: 'sign-up-details',
    components: { DFooter, Swipe, SwipeItem },
    data() {
      return {
        active: 1,
        total: 4,
        images: [
          require('../../assets/images/examples/header.png'),
          require('../../assets/images/training/bg1.png'),
          require('../../assets/images/training/bg2.png')
        ]
      }
    },
    methods: {
      onChange(index) {
        this.active = index
      }
    }
  }
</script>

<style scoped lang="scss">
  .img {
    width: 100%;
    height: 200px;
  }

  .my-swipe {
    position: relative;
  }

  .custom-indicator {
    position: absolute;
    right: 8px;
    bottom: 30px;
    width: 28px;
    height: 18px;
    border-radius: 2px;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 18px;
    background: rgba(0, 0, 0, 0.6);
  }

  .content {
    width: 100%;
    min-height: 400px;
    background: #ffffff;
    border-radius: 16px 16px 0 0;
    position: absolute;
    margin-top: -20px;
    padding: 16px 12px;

    &-title {
      height: 50px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 25px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    &-date {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-top: 12px;
      padding-bottom: 16px;
      box-shadow: 0px 1px 0px 0px #e9e9e9;
    }

    &-label {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 22px;
      margin-top: 16px;
      padding-left: 16px;
      position: relative;

      &::after {
        content: '';
        width: 8px;
        height: 8px;
        border: 2px #5d8fd4 solid;
        box-sizing: border-box;
        border-radius: 50%;
        position: absolute;
        top: 12px;
        left: -8px;
        margin-top: -4px;
        margin-left: 8px;
      }
    }

    &-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 21px;
      margin-top: 8px;
    }

    .footer {
      width: 375px;
      height: 50px;
      border-top: 1px #e9e9e9 solid;
      box-sizing: border-box;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: right;

      button {
        width: 160px;
        height: 40px;
        border-radius: 20px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 40px;
        background: none;
        margin-right: 12px;

        &.cancel {
          border: 1px solid #165ebf;
          color: #165ebf;
          background: #ffffff;
        }

        &.confirm {
          border: 1px solid #165ebf;
          color: #ffffff;
          background: #165ebf;
        }
      }
    }
  }
</style>
